export function getTotalCountHeader(response) {
  const totalCountHeader = response.headers['x-total-count'];
  return totalCountHeader ? parseInt(totalCountHeader) : 0;
}
